import {
    ITaskBasePreview,
    ITaskListPreview,
    TaskPreviewAdditionalInformation,
    TaskSubject,
} from '@lib/workflow-integration';
import { IDemandPrice } from '../../demand/types/DemandPrice';
import { IPerson, PersonExtended } from '@lib/user';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { PriceFormatter } from '@lib/util';
import { supplierDisplayName } from '@lib/supplier';

export interface IPurchaseRequisitionTaskPreview extends ITaskBasePreview {
    purchaseRequisitionNumber: string;
    price: IDemandPrice[];
    consumer: IPerson;
    suppliers: { name: string; supplierNumber?: string | null }[];
}

export class PurchaseRequisitionTaskPreview implements ITaskListPreview {
    public readonly id: string;
    public readonly created: string;
    public readonly formKey: string;
    public readonly subject: TaskSubject;
    public readonly subjectIdentifier: string;
    public readonly assignee?: IPerson | null;

    public readonly additionalInformation: TaskPreviewAdditionalInformation[];

    constructor(
        dto: IPurchaseRequisitionTaskPreview,
        public readonly displayName: string,
    ) {
        this.id = dto.id;
        this.formKey = dto.formKey;
        this.created = dto.created;
        this.subject = TaskSubject.PURCHASE_REQUISITION;
        this.subjectIdentifier = dto.purchaseRequisitionNumber;
        this.assignee = dto.assignee;
        const consumer = new PersonExtended(dto.consumer);
        const suppliers = dto.suppliers.map((supplier) =>
            supplierDisplayName(supplier.supplierNumber, supplier.name),
        );

        this.additionalInformation = [
            new TaskPreviewAdditionalInformation(marker('Bedarfsträger'), [consumer.valueDisplay]),
            new TaskPreviewAdditionalInformation(
                marker('Lieferanten'),
                suppliers.length > 0 ? suppliers : [marker('Keine Lieferanten')],
            ),
        ];
        for (const price of dto.price) {
            this.additionalInformation.push(
                new TaskPreviewAdditionalInformation(marker('Preis'), [
                    PriceFormatter.format(price.netPrice, price.currency),
                ]),
            );
        }
    }
}
